import { colors, s16 } from '@ardoq/design-tokens';
import { text2 } from '@ardoq/typography';
import { ChevronIcon } from '@ardoq/icons';
import styled from 'styled-components';
import { SidebarAlignment } from './types';

export type OpenState = 'closed' | 'preview' | 'open';

// Sidebar Body
export const Item = styled.div<{
  $shouldGrow: boolean;
  $isExpanded: boolean;
}>`
  background-color: ${colors.surfaceDefault};
  color: ${colors.textDefault};
  transition-duration: 150ms;
  transition-property: background-color;
  transition-delay: 150ms;
  padding: ${s16};
  ${text2};
  flex: ${props => (props.$shouldGrow ? '1 0 100px' : 'none')};
  box-sizing: border-box;
  overflow: ${props => (props.$isExpanded ? 'visible' : 'hidden')};
  display: flex;
  flex-direction: column;
  &:not(:last-of-type) {
    margin-bottom: 16px;
  }
`;

export const Expander = styled.p`
  color: ${colors.textAction};
  cursor: pointer;
  margin: 0;
  padding: ${s16} 0 0 0;
`;

export const ExpandedWrapperEllipsis = styled.div<{
  $showMore: boolean;
  $lineMax: number;
}>`
  width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${props => (props.$showMore ? 'unset' : props.$lineMax)};
  -webkit-box-orient: vertical;
  margin: 0;
`;

export const ExpandedWrapperOverflow = styled.div<{ $showMore: boolean }>`
  overflow: ${props => (props.$showMore ? 'visible' : 'hidden')};
  margin: 0;
`;

const getChevronDirection = (
  openState: OpenState,
  alignment: SidebarAlignment
) => {
  switch (openState) {
    case 'open':
      return alignment === 'left' ? 'left' : 'right';
    case 'closed':
      return alignment === 'left' ? 'right' : 'left';
    default:
      return 'left';
  }
};

export const SidebarChevron = ({
  openState,
  alignment,
}: {
  openState: OpenState;
  alignment: SidebarAlignment;
}) => (
  <ChevronIcon
    direction={getChevronDirection(openState, alignment)}
    style={{
      background: colors.grey200,
      borderRadius: 12,
      boxShadow: `1px 2px 3px 1px ${colors.borderAction}`,
    }}
  />
);
